import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {
  showForVatRateCountry, FieldText, hideForVatRateCountry, FormProps,
  ClosedContentProps, lovValue, IDomainObject, isForVatRateCountry
} from 'core/form/formUtils';
import partyService from 'party/partyService';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {valid, invalid, validWarn} from 'core/form/rules';
import { StatusActiveComp__h5_style} from "core/components/buttons/statusActiveComp";
import {observer} from "mobx-react";
import {Party, COUNTRY, Address, PARTYCATEGORY, PartyInfo} from "party/partyDomain";
import pull = require("lodash/pull");
import {action} from "mobx";
import styled from "styled-components";
import {green500} from "material-ui/styles/colors";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {PartyActiveComp} from "party/component/partyActiveComp";
import mdEntityService from "core/metamodel/mdEntityService";
import securityService from "core/security/securityService";
import {PERMISSION, SECURABLE, SECURABLE_TYPE} from "core/metamodel/metaConstant";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";
import {RESTRICTION} from "core/security/securityDomain";

function PartyExist({value, partyId}): any {
  if (!value) return valid();
  return partyService.partyExist({ico: value, partyId})
    .then( (exists) => (exists) ? invalid(`Customer with ICO ${value} already exists`) : valid());
}

function PartyVatIdExist({value, nationality}): any {
  if (!value) return valid();
  return partyService.partyVatIdExist({vatId: value, nationality})
    .then( (exists) => (exists === true) ? valid() : ((exists === false) ? validWarn("VAT ID not found in EU register") : validWarn("EU register is down")) );
}

function PartyIdExist({value}): any {
  if (!value) return valid();
  return partyService.partyIdExist({id: value})
    .then( (exists) => (exists === true) ? valid() : ((exists === false) ? validWarn("ID not found in ARES") : validWarn("ARES is down")) );
}

const SpanCheck = styled.span`
  color: ${green500};
  margin-left: 3px;
`;


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<Party>) => (
  <div>

    <div style={{display: 'flex'}}>
      { disabled ? null :  <PartyActiveComp partyObject={dataObject} entity={entity} partyCategoryEntity={mdEntityService.getEntity("PARTYCATEGORY")}/>}
      <h5 style={StatusActiveComp__h5_style}> {dataObject.fullName}</h5>
    </div>


    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      {(isForVatRateCountry(COUNTRY.RO)) ? null :  <ClosedFormField label={fields.ico.textLabel} value={dataObject.ico} />}
      <ClosedFormField label={fields.dic.textLabel}>
        <span>{dataObject.dic}</span>
        {(dataObject.vatIdCheckDate) ? <SpanCheck className="fa fa-check"/> : null}
      </ClosedFormField>
      {(isForVatRateCountry(COUNTRY.SK, COUNTRY.HU)) ? <ClosedFormField label={fields.icoDph.textLabel} value={dataObject.icoDph} /> : null}
      <ClosedFormField label={fields.defaultCurrency.textLabel} value={dataObject.defaultCurrency}/>
      <ClosedFormField label={fields.defaultLanguage.textLabel} value={dataObject.defaultLanguage}/>
      <ClosedFormField label={fields.defaultPaymentCond.textLabel} value={dataObject.defaultPaymentCond}/>
      <ClosedFormField label={fields.legalForm.textLabel} value={dataObject.legalForm}/>
      <ClosedFormField label={fields.naceCode.textLabel} value={dataObject.naceCode}/>
      <ClosedFormField label={fields.marketingSource.textLabel} value={dataObject.marketingSource}/>
      <ClosedFormField label={fields.nationality.textLabel} value={dataObject.nationality}/>
      <ClosedFormField label={fields.taxDomicile.textLabel} value={dataObject.taxDomicile}/>
      <ClosedFormField label={fields.defaultSendType.textLabel} value={dataObject.defaultSendType}/>
      <ClosedFormField label={fields.defaultAttachmentType.textLabel} value={dataObject.defaultAttachmentType}/>
      <ClosedFormField label={fields.defaultProfitCenter.textLabel} value={dataObject.defaultProfitCenter}/>
      <ClosedFormField label={fields.vatRateOverride.textLabel} value={dataObject.vatRateOverride}/>
      <ClosedFormField label={fields.commercialRegister.textLabel} value={dataObject.commercialRegister}/>

      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.firstName.textLabel} value={dataObject.firstName}/> : null}
      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.lastName.textLabel} value={dataObject.lastName}/> : null}
      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.dateOfBirth.textLabel} value={dataObject.dateOfBirth} mdField={fields.dateOfBirth.mdField} /> : null}
      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.birthNumber.textLabel} value={dataObject.birthNumber}/> : null}
      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.gender.textLabel} value={dataObject.gender}/> : null}
      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.birthLastName.textLabel} value={dataObject.birthLastName}/> : null}
      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.salutation.textLabel} value={dataObject.salutation}/> : null}
      { (dataObject.partyCategory === PARTYCATEGORY.EN) ? <ClosedFormField label={fields.placeOfBirth.textLabel} value={dataObject.placeOfBirth}/> : null}



    </ClosedFormBlock>

  </div>
);



@createForm({
  formName: 'PartyPoForm',
  fields: [{
    name: 'fullName',
    validators: ['IsRequired']
  }, {
    name: 'ico'
  }, {
    name: 'dic'
  }, {
    name: 'icoDph'
  }, {
    name: 'defaultCurrency'
  }, {
    name: 'defaultLanguage'
  }, {
    name: 'defaultPaymentCond'
  }, {
    name: 'legalForm'
  }, {
    name: 'naceCode'
  }, {
    name: 'marketingSource'
  }, {
    name: 'nationality'
  }, {
    name: 'taxDomicile'
  }, {
    name: 'commercialRegister'
  }, {
    name: 'defaultSendType'
  }, {
    name: 'defaultAttachmentType',
  }, {
    name: 'defaultProfitCenter'
  }, {
    name: 'firstName',
    validators: ['IsRequired']
  }, {
    name: 'lastName',
    validators: ['IsRequired']
  }, {
    name: 'titleBefore'
  }, {
    name: 'dateOfBirth'
  }, {
    name: 'birthNumber'
  }, {
    name: 'gender'
  }, {
    name: 'birthLastName'
  }, {
    name: 'salutation'
  }, {
    name: 'placeOfBirth'
  }, {
    name: 'vatRateOverride'
  }]
}, ClosedContent)
@observer
export default class PartyPoForm extends React.Component<FormProps<Party, Party>, undefined> {


  @action onDic = (evt) => {
    evt.preventDefault();
    let {dataObject, form} = this.props;
    console.log('onDic', evt);
    partyService.partyVatIdDownload({vatId: dataObject.dic, nationality: lovValue(dataObject.nationality), language: lovValue(dataObject.defaultLanguage)})
      .then(action("partyVatIdDownload-actionCb", this.processPartyInfo));
  };

  @action onIco = (evt) => {
    evt.preventDefault();
    let {dataObject} = this.props;
    console.log('onIco', evt);
    partyService.partyIdDownload({id: dataObject.ico})
      .then(action("partyIdDownload-actionCb", this.processPartyInfo));
  };

  @action onSuccessDic = () => {
    let {form, dataObject} = this.props;
    if (form.getField("dic").errorText) {
      dataObject.vatIdCheckDate = null;
    } else {
      dataObject.vatIdCheckDate = new Date();
    }
  };

  processPartyInfo = (json: IDomainObject) => {
    let {dataObject, form} = this.props;
    if (json) {
      let oldPA = dataObject.partyPermanentAddress();
      if (oldPA) {
        pull(dataObject.addresses, oldPA);
      }
      let partyInfo = new PartyInfo(json);
      let address = partyInfo.permanentAddress;
      let bankAccount = partyInfo.defaultBankAccount;
      if (address) {
        dataObject.fullName = address.name;
        dataObject.nationality = address.country;
        dataObject.taxDomicile = address.country;
      }
      dataObject.ico = partyInfo.id;
      dataObject.dic = partyInfo.vatId;
      form.updateFieldsPropValue(dataObject, "ico", "dic", "fullName", "nationality", "taxDomicile");

      if (address) {
        address.name = null;
        dataObject.addresses.push(address);
      }
      if (bankAccount) {
        if (!dataObject.bankAccounts.find(account => { // if account doesn't already exist
          return account.accountNumber == bankAccount.accountNumber
          && account.bank.value == bankAccount.bank.value
          && account.accountPrefix == bankAccount.accountPrefix
          && account.currency.value == bankAccount.currency.value
        })) {
          dataObject.bankAccounts = [...dataObject.bankAccounts, bankAccount];
        }
      }
    }
  }

  onDicEnable = (value) => {
    return ((this.props.dataObject.$new || this.props.dataObject.$dirty) && value && value.length > 2);
  };

  onIcoEnable = (value) => {
    return ((this.props.dataObject.$new || this.props.dataObject.$dirty) && value);
  }


  render() {


    let {dataObject, rootObject, entities, entity, open, formName} = this.props;
    const fields = dataObject.getFormFields(formName);
    let {fullName, ico, dic, icoDph, defaultCurrency, defaultLanguage, defaultPaymentCond, legalForm, naceCode, marketingSource,
      nationality, taxDomicile, commercialRegister, defaultSendType, defaultAttachmentType, defaultProfitCenter, firstName, lastName, titleBefore,
      dateOfBirth, birthNumber, gender, birthLastName, placeOfBirth, vatRateOverride} = fields;

    let defaultProfitCenterOptions = (securityService.currentUser.hasRestriction(RESTRICTION.LIMIT_PARTY_BY_USER_PROFITCENTER)) ?
      defaultProfitCenter.props.options.filter(lv => securityService.restrictionData.userProfitCenterIds.includes(lv.value)) : defaultProfitCenter.props.options;



    let openContent = (
      <div>

        {/*  1. row  */}
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...fullName.props} />
            <Validate field={fullName} value={fullName.props.value}/>
          </div>
        </div>

        {/*  2. row  */}
        <div className="row">
          {hideForVatRateCountry(<div className="fx col-xs-6 col-sm-4">
            <MdTextField {...ico.props} showValidationIcon={true} onAction={this.onIco} onActionEnable={this.onIcoEnable} />
            <Validate field={ico} value={ico.props.value}>
              <PartyExist partyId={dataObject.partyId} />
              <PartyIdExist />
            </Validate>
          </div>, COUNTRY.RO)}
          <div className="fx col-xs-6 col-sm-4">
            <MdTextField {...dic.props} showValidationIcon={true} onAction={this.onDic} onActionEnable={this.onDicEnable} />
            <Validate field={dic} value={dic.props.value} onSuccess={this.onSuccessDic}>
              <PartyVatIdExist nationality={lovValue(dataObject.nationality)} />
            </Validate>
          </div>
          {showForVatRateCountry(
            (<div className="fx col-xs-6 col-sm-4">
              <MdTextField {...icoDph.props} />
            </div>), COUNTRY.SK, COUNTRY.HU)}
        </div>

        {/*  3. 4. 6. row  */}
        <div className="row">
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...defaultCurrency.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...defaultLanguage.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...defaultPaymentCond.props}  />
          </div>

          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...legalForm.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...naceCode.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...marketingSource.props}  />
          </div>

          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...nationality.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...taxDomicile.props} />
            <Validate field={taxDomicile} value={taxDomicile.props.value} dataObject={dataObject}/>
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...defaultSendType.props} />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...defaultProfitCenter.props} options={defaultProfitCenterOptions}  />
            <Validate field={defaultProfitCenter} value={defaultProfitCenter.props.value} dataObject={dataObject}/>
          </div>
          { (securityService.hasRight(SECURABLE.vatRateOverride.name, PERMISSION.Update)) ? (
            <div className="fx col-xs-6 col-sm-4">
              <StyledSelect {...vatRateOverride.props} />
            </div>
          ) : null}
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...defaultAttachmentType.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...commercialRegister.props} />
          </div>
        </div>

        { (dataObject.partyCategory === PARTYCATEGORY.EN) ? (
          <div className="row">
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...firstName.props} />
              <Validate field={lastName} value={lastName.props.value}/>
            </div>
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField  {...lastName.props}/>
              <Validate field={lastName} value={lastName.props.value}/>
            </div>
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...titleBefore.props} />
            </div>
            <div className="fx col-xs-6 col-sm-4">
              <StyledDatePicker {...dateOfBirth.props}  />
            </div>
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...birthNumber.props}  />
            </div>
            <div className="fx col-xs-6 col-sm-4">
              <StyledSelect {...gender.props}  />
            </div>
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...birthLastName.props}  />
            </div>
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...placeOfBirth.props}  />
            </div>
          </div>
        ) : null}

      </div>
    );



    return (open) ? openContent : (
      <BlockComp noPadding={true}>
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }

}





// WEBPACK FOOTER //
// ./src/party/component/partyPoForm.tsx